import { api } from "../client";
import type { MeetingRecord } from "@/features/meetings/types";

export interface ComposeEmailRequest {
  to: string[];
  subject: string;
  content: string;
  html_content?: string;
  cc?: string[];
  bcc?: string[];
}

export interface ComposeEmailResponse {
  success: boolean;
  message: string;
  message_id?: string;
}

export const meetingsApi = {
  listMeetings: async (folderId?: string | null): Promise<MeetingRecord[]> => {
    // folderId: undefined / null / "all" → no filter; UUID → that folder;
    // "unfiled" → meetings not in any folder.
    const path =
      folderId && folderId !== "all"
        ? `/v1/intelligence/meetings?folder_id=${encodeURIComponent(folderId)}`
        : "/v1/intelligence/meetings";
    return api.get<MeetingRecord[]>(path);
  },
  getMeeting: async (id: string): Promise<MeetingRecord> => {
    return api.get<MeetingRecord>(`/v1/intelligence/meetings/${id}`);
  },
  trashMeeting: async (id: string): Promise<void> => {
    return api.delete<void>(`/v1/intelligence/meetings/${id}`);
  },
  stopMeeting: async (sessionId: string): Promise<void> => {
    return api.post<void>("/v1/meetings/session/stop", { session_id: sessionId });
  },
  sendEmail: async (payload: ComposeEmailRequest): Promise<ComposeEmailResponse> => {
    return api.post<ComposeEmailResponse>("/v1/compose/compose", payload);
  },
};
